/**
 * Banner scripts.
 *
 * Handles sticky behavior of the banner.
 */

/** Dependencies -------------------------------------------- */

// External

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

// Design system

import { setupEventName as smoothScrollSetupEventName } from '../smooth-scroll'
import { getCssVar } from '../helpers'

/** The beef ------------------------------------------------ */

/**
 * Header mixin.
 * Provides header functionality to single element.
 */
export let mixin = ( { node = null, config = {} } = {} ) => {

    if ( ! node ) return false

    let state = {
        node,
        config
    }

    let module = {

		/** Utilities -------------------------------------- */

		/** Animations -------------------------------------- */

		setAnimations() {

			// Sticky magic

			ScrollTrigger.create(
				{
					trigger    : state.node,
					start      : () => `top ${getCssVar( state.config.offsetVar, state.node )}px`,
					end        : 'max',
					pin        : true,
					pinSpacing : false
				}
			)
		},

		/** Event handlers ---------------------------------- */

		onSmoothScrollSetup() {
			this.setAnimations()
		},
		
		/** Setup ------------------------------------------- */

		setEventBindings() {
			window.addEventListener( smoothScrollSetupEventName, this.onSmoothScrollSetup.bind( this ) )
		},
        
        init() {
			this.setEventBindings()			
        },
    }

    return module.init()
};

/**
 * Banner module.
 * Provides an interface to apply banner functionality to all elements matching a selector.
 */
export default {

    init( { className, config = {} } ) {

        let selected = document.querySelectorAll( `.${className}` )

        if ( ! selected.length ) return

        const defaultConfig = {
            offsetVar : 'bannerOffset',
        }

        return Array.from( selected ).map(
            ( node, index ) => mixin( { node, config: { ...defaultConfig, ...config, className } } )
        )
    }
}
